import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import './index.css';
import { throttle } from 'lodash';

interface Props {
    options: echarts.EChartsOption,
    height?: string
    onclick?: Function
    onclickBar?: Function
}

const ChartBar: React.FC<Props> = (props) => {
    const chartDom = React.createRef<HTMLDivElement>();

    useEffect(() => {
        if (chartDom && chartDom.current) {
            const myChart = echarts.init(chartDom.current as any, undefined, { renderer: 'svg' });
            myChart.setOption(props.options);

            if (props.onclickBar) {
                myChart.on('click', function (params) {
                    props.onclickBar && props.onclickBar(params);
                });
            }

            const resizeObserver = new ResizeObserver(throttle(() => {
                myChart.resize();
            }, 100));

            resizeObserver.observe(chartDom.current);

            return () => {
                if (chartDom.current) {
                    resizeObserver.unobserve(chartDom.current);
                }
            };
        }
    }, [props.options]);

    return (
        <div
            className={"hhchart bar"}
            style={{ height: props.height && `${props.height}`}}
            onClick={() => props.onclick && props.onclick()}
        >
            <div className={"chart"}>
                <div className={"body"} ref={chartDom} style={{ cursor: (props.onclick) ? "pointer" : undefined }} />
            </div>
        </div>
    );
}

export default ChartBar;